import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Wrapper from "../UI/Wrapper";
import "../../components/LeadExpenseListView/LeadExpenseListView.css";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function LeadExpenseListView({ relocationId }) {
  const baseAPI = process.env.REACT_APP_API_URL;
  const storedToken = JSON.parse(localStorage.getItem("token"));
  const [expenseDetail, setExpenseDetail] = useState([]);
 const baseImageURL = process.env.REACT_APP_IMAGE_URL;


  useEffect(() => {
    getExpenseList();
  }, []);

  const getExpenseList = async () => {
    if (storedToken) {
      axios
        .get(`${baseAPI}UserGet/GetFieldOpsExpenseDetail?RelocationId=${relocationId}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setExpenseDetail(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  
  return (
    <>
      <div>
        <Wrapper className="ViewLeadDetails">
          <div className="Petment-Details1" style={{ display: "flex", flexDirection: "row" }}><h3 class="order-summary-title">Expense Detail</h3></div>
          <div
            style={{
              width: "100%",
              alignItems: "center",
            }}
          >
            <table
              className="customerDetailsTable"
              style={{ width: "99%", marginLeft: "5px" }}
            >
              <div className="undefined" style={{ width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      padding: "11px 0 0 0",
                      
                    }}
                  >
                    <table style={{ width: "100%" }} className="table_supplier">
                      <thead>
                        <tr className="employeeListHeading">
                          <th  style={{width:"5%"}} >S.No.</th>
                          <th style={{width:"5%"}}>Expense ID</th>
                          <th style={{width:"5%"}}>Relocation ID</th>
                          <th style={{width:"10%"}}>Job ID</th>
                          <th style={{width:"10%"}}>Amount</th>
                          <th style={{width:"15%"}}>Description</th>
                          <th style={{width:"15%"}}>Expense Type</th>
                          <th style={{width:"10%"}}>Payment Mode</th>
                          <th style={{width:"15%"}}>Added By</th>
                          <th>Document</th>
                        </tr>
                      </thead>
                      <tbody>
                        {expenseDetail !== null ? (
                          expenseDetail.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.Expense_Id}</td>
                              <td>{item.Relocation_Id}</td>
                              <td>{item.Job_Id}</td>
                              <td>{item.Amount}</td>
                              <td>{item.Description}</td>
                              <td>{item.expense_Type_name}</td>
                              <td>{item.payment_mode_name}</td>
                              <td>{item.added_by}</td>
                              {item.Document !== "" ? (
                                <td>
                                  {" "}
                                  <a
                                    style={{
                                      color: "#6a6a6a",
                                      textDecoration: "none",
                                      cursor: "pointer",
                                      fontWeight: "bold",
                                    }}
                                    target="_blank"
                                    href={`${baseImageURL}Images/FieldOpsExpenseDocuments/${item.Document}`}
                                  >
                                    View Document <ArrowForwardIcon />
                                  </a>
                                </td>
                              ) : (
                                <td>
                                  {" "}
                                  <p style={{ color: "#6a6a6a", textDecoration: "none" }}>
                                    No Document Uploaded
                                  </p>
                                </td>
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10">No Expense Has Been Added</td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </table>
          </div>
        </Wrapper>
      </div>
    </>
  );
}

export default LeadExpenseListView;
